export const WordsInputList = {
  Default: {
    LABEL: "Список полів вводу",
    WORD_PLACEHOLDER: "Слово",
    HINT_PLACEHOLDER: "Підказка",
    ADD_INPUT_BUTTON: "Додати поле вводу",
  },
};
